"use client"

import { cn } from "@/lib/utils"
import MainCheck from "@/assets/icons/main-check.svg"
import { TooltipInfo } from "@/components/ui/tooltip-info"
import { CircleDashed } from "lucide-react"

interface CheckItemProps {
    text: string;
    className?: string;
    tooltip?: string;
    isNotIncluded?: boolean;
}

export function CheckItem({ text, className, tooltip, isNotIncluded }: CheckItemProps) {
    return (
        <div className={cn("flex gap-3 pt-1")}>
            <div className="flex pt-0.5">
                {isNotIncluded ? (
                    <CircleDashed className="w-4 h-4 text-gray-400" />
                ) : <MainCheck />}
            </div>
            <div className={cn("flex text-sm gap-1", isNotIncluded ? "text-gray-400" : "text-natural-500", className)}>
                {text}
            </div>
            {tooltip && !isNotIncluded && <TooltipInfo text={tooltip} title={text} />}
        </div>
    );
}